/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Cta_BodyInputs */

const en_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a lesson and start building your spot on the wall.`)
};

const es_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva una lección y empieza a ganarte tu lugar en la pared.`)
};

const de_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie eine Unterrichtsstunde und beginnen Sie mit dem Aufbau Ihres Platzes an der Wand.`)
};

const zh_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预订课程并开始在墙上建立你的位置。`)
};

const ar_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً وابدأ بناء مكانك على الجدار.`)
};

const fr_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon et commencez à construire votre place sur le mur.`)
};

const vi_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học và bắt đầu xây dựng chỗ của bạn trên tường.`)
};

const sw_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agiza somo na anza kujenga eneo lako ukutani.`)
};

const th_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียนและเริ่มสร้างจุดของคุณบนผนัง`)
};

const bs_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekciju i počnite graditi svoje mjesto na zidu.`)
};

const ja_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンを予約して、殿堂の壁に名を刻む第一歩を。`)
};

const ko_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수업을 예약하고 벽에 자리 잡고 시작하십시오.`)
};

const pt_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula e comece a conquistar seu lugar na parede.`)
};

const it_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione e inizia a costruire il tuo posto sul muro.`)
};

const sv_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en lektion och börja bygga din plats på väggen.`)
};

const nl_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek een les en begin met het bouwen van uw plek op de muur.`)
};

const da_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion og begynde at bygge din plet på væggen.`)
};

const nb_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en leksjon og start å bygge din plass på veggen.`)
};

const fi_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunti ja ala rakentaa paikkaa seinälle.`)
};

const pl_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję i zacznij budować swoje miejsce na ścianie.`)
};

const ru_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закажите урок и начните строить свое место на стене.`)
};

const tr_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir ders ayırtın ve duvardaki yerinizi kazanmaya başlayın.`)
};

const hi_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक सबक बुक करें और दीवार पर अपना स्थान बनाना शुरू करें।`)
};

const id_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesankan pelajaran dan mulai bangun tempatmu di dinding.`)
};

const ms_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran dan mula membina tempat anda di dinding.`)
};

const cs_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervujte si lekci a začněte stavět své místo na zdi.`)
};

const el_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάνε ένα μάθημα και άρχισε να χτίζεις τη θέση σου στον τοίχο.`)
};

const he_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו שיעור והתחילו לבנות את המקום שלכם על הקיר.`)
};

const af_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek 'n les en begin jou plek op die muur verdien.`)
};

const hu_hof_cta_body = /** @type {(inputs: Hof_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalj egy leckét, és kezdd el építeni a helyed a falon.`)
};

/**
* | output |
* | --- |
* | "Book a lesson and start building your spot on the wall." |
*
* @param {Hof_Cta_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_cta_body = /** @type {((inputs?: Hof_Cta_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Cta_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_cta_body(inputs)
	if (locale === "de") return de_hof_cta_body(inputs)
	if (locale === "zh") return zh_hof_cta_body(inputs)
	if (locale === "ar") return ar_hof_cta_body(inputs)
	if (locale === "fr") return fr_hof_cta_body(inputs)
	if (locale === "vi") return vi_hof_cta_body(inputs)
	if (locale === "sw") return sw_hof_cta_body(inputs)
	if (locale === "th") return th_hof_cta_body(inputs)
	if (locale === "bs") return bs_hof_cta_body(inputs)
	if (locale === "ja") return ja_hof_cta_body(inputs)
	if (locale === "ko") return ko_hof_cta_body(inputs)
	if (locale === "pt") return pt_hof_cta_body(inputs)
	if (locale === "it") return it_hof_cta_body(inputs)
	if (locale === "sv") return sv_hof_cta_body(inputs)
	if (locale === "nl") return nl_hof_cta_body(inputs)
	if (locale === "da") return da_hof_cta_body(inputs)
	if (locale === "nb") return nb_hof_cta_body(inputs)
	if (locale === "fi") return fi_hof_cta_body(inputs)
	if (locale === "pl") return pl_hof_cta_body(inputs)
	if (locale === "ru") return ru_hof_cta_body(inputs)
	if (locale === "tr") return tr_hof_cta_body(inputs)
	if (locale === "hi") return hi_hof_cta_body(inputs)
	if (locale === "id") return id_hof_cta_body(inputs)
	if (locale === "ms") return ms_hof_cta_body(inputs)
	if (locale === "cs") return cs_hof_cta_body(inputs)
	if (locale === "el") return el_hof_cta_body(inputs)
	if (locale === "he") return he_hof_cta_body(inputs)
	if (locale === "af") return af_hof_cta_body(inputs)
	if (locale === "hu") return hu_hof_cta_body(inputs)
	return en_hof_cta_body(inputs)
});